// Dimensions et constantes du canvas
export const CANVAS_BASE_WIDTH = 1045;
export const CANVAS_BASE_HEIGHT = 665;
export const CANVAS_RATIO = CANVAS_BASE_WIDTH / CANVAS_BASE_HEIGHT;

// Paramètres de grille par défaut
export const DEFAULT_GRID_COLUMNS = 28;
export const DEFAULT_GRID_ROWS = 18;

// Hauteurs des barres
export const TOP_BAR_HEIGHT = 45;
export const CONTROL_BAR_HEIGHT = 22;
export const BOTTOM_BAR_HEIGHT = 100 + CONTROL_BAR_HEIGHT;

// Dimensions de la timeline
export const timelineHeight = 20;
export const amplitudeSliderWidth = 25;

// Sidebar
export const SIDEBAR_WIDTH = 280;
export const MIN_MARGIN = 10;

// Threshold pour détection de clic
export const THRESHOLD = 5;

// Couleurs des skills
export const skillColors = [
  "#36949d", "#ff924c", "#1982c4", "#ffca3a",
  "#4267ac", "#c5ca30", "#565aa0", "#8ac926", "#6a4c93",
  "#e97c61", "#e9c46a", "#e76f51", "#8ab17d", "#ee8959",
  "#2a9d8f", "#f4a261", "#287271", "#efb366", "#264653", "#ff595e"
];
